import { useAuth } from '@/features/auth/hooks/use-auth';
import { Building2 } from 'lucide-react';
import { SearchableSelect } from '@/components/ui/searchable-select';
import { pedirSalida } from '@/lib/salida-con-cambios';

export function OrgSwitcher() {
  const { organizations, activeOrganizationId, switchOrganization, isAdmin } = useAuth();

  // No mostrar si no hay organizaciones
  if (organizations.length === 0) {
    return null;
  }

  // Opciones del selector
  const options = [
    // Admins pueden ver "Todas"
    ...(isAdmin ? [{ value: '__all__', label: 'Todas las organizaciones' }] : []),
    ...organizations.map((org) => ({
      value: org.id,
      label: `${org.name} (${org.code})`,
    })),
  ];

  const handleChange = (value: string) => {
    const orgId = value === '__all__' ? null : value;
    // Spec 294: con cambios propios sin aplicar en Reglas, cambiar de organización
    // (recarga la página) pregunta antes.
    pedirSalida(() => {
      switchOrganization(orgId);
      // Recargar datos con la nueva org
      window.location.reload();
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Building2 className="w-4 h-4 text-muted-foreground flex-shrink-0" />
      <SearchableSelect
        options={options}
        value={activeOrganizationId || '__all__'}
        onValueChange={handleChange}
        placeholder="Seleccionar organización"
        searchPlaceholder="Buscar organización..."
        className="w-[200px]"
      />
    </div>
  );
}

export default OrgSwitcher;
